export default "__VITE_ASSET__EIxP_pAp__"